export interface TagAttrs {
  clickable?: boolean;
  removable?: boolean;
  icon?: string;
  size?: TagSize;
  'tag-name': string;
  theme?: TagTheme;
}

export enum TagTheme {
  Light = `light`,
  Secondary = `secondary`,
  Breadcrumb = `breadcrumb`,
}

export enum TagSize {
  Small = `small`,
  Default = `default`,
}

export type TagEvent = {tagName: string};

export interface TagJsxProps {
  attrs: TagAttrs;
  on?: {
    select?: (ev: CustomEvent<TagEvent>) => void;
    remove?: (ev: CustomEvent<TagEvent>) => void;
  };
}
